import apiUrl from '../baseUrls/functions';
import AxiosService from '../axiosConfig/AxiosService';

export default new class PieceRechangeService {
    
    get = (callback, queryParams) => AxiosService.get(apiUrl('/api/crud/piece-rechange/get'), callback, queryParams);
    getStock = (callback, queryParams) => AxiosService.get(apiUrl('/api/crud/piece-rechange/stock'), callback, queryParams);
    getById = (id, callback) => AxiosService.get(apiUrl(`/api/crud/piece-rechange/get/${id}`), callback);
    add = (data, callback) => AxiosService.post(apiUrl('/api/crud/piece-rechange/add'), data, callback);
    update = (data, callback) => AxiosService.put(apiUrl('/api/crud/piece-rechange/update'), data, callback);
    delete = (id, callback) => AxiosService.delete(apiUrl(`/api/crud/piece-rechange/delete/${id}`), callback);
    
}